import React from "react";
import {Card, CardActionArea, CardContent, CardMedia, Grid, Typography} from "@mui/material";
import {Link as RouterLink} from "react-router-dom";
import PageLayout from "../components/layout/PageLayout";
import cashFlowPreview from "../assets/reports/cash-flow.svg";
import barChartPreview from "../assets/reports/bar-chart.svg";
import {useTranslation} from "react-i18next";

const ReportsCashFlowPage = () => {
    const {t} = useTranslation();
    return (
        <PageLayout title={t("pages.reports.cashFlow.title")}>
            <CardContent sx={{minHeight: 200, maxHeight: "90%", overflowY: "auto"}}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{height: "100%"}}>
                            <CardActionArea component={RouterLink} to="/reports/cash-flow/balances">
                                <CardMedia
                                    component="img"
                                    height="160"
                                    image={cashFlowPreview}
                                    alt={t("pages.reports.cashFlow.cards.balances.alt")}
                                />
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {t("pages.reports.cashFlow.cards.balances.title")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {t("pages.reports.cashFlow.cards.balances.description")}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Card sx={{height: "100%"}}>
                            <CardActionArea component={RouterLink} to="/reports/cash-flow/waterfall">
                                <CardMedia
                                    component="img"
                                    height="160"
                                    image={barChartPreview}
                                    alt={t("pages.reports.cashFlow.cards.waterfall.alt")}
                                />
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        {t("pages.reports.cashFlow.cards.waterfall.title")}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {t("pages.reports.cashFlow.cards.waterfall.description")}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                </Grid>
            </CardContent>
        </PageLayout>
    );
};

export default ReportsCashFlowPage;
